export default "__VITE_ASSET__CFlNc5hU__"